import React, { memo, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { useLocation } from 'react-router-dom';
import qs from 'query-string';

import Button from '../../components/Button/Button';
import Rate from '../../components/Rate/Rate';
import { logging } from '../../actions/log';
import styles from './SoftDetailSimple.module.less';
import Btn from '../../components/Btn/Btn';
import { setFasterProduct } from '../../actions/layout';
import { formatMoney } from '../../utils/utils';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

export default memo(({ softDetails, match }) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const logInfoData = useSelector(selectLogInfo);
  const search = qs.parse(location?.search) || {};

  useEffect(() => {}, [dispatch]);
  const handleFasterProduct = () => {
    dispatch(
      setFasterProduct({
        soft: { ...softDetails, bizInfo: match.params.bizInfo },
        info: { isFasterProduct: true },
        logInfo: { source: 'AppDetail' },
      }),
    );
    // 打桩
    dispatch(
      logging({
        category: 'C',
        action: 'Accelerate',
        label: '',
        param2: {
          source: 'AppDetail',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          softid: softDetails.softID || softDetails.SoftID,
          softType: '0',
          accelerate: softDetails.appRecommend && softDetails.appRecommend.softId,
        },
        param3: softDetails.bizInfo,
      }),
    );
  };

  const formatDiscount = (current, original) => {
    let cp = parseFloat(current);
    let op = parseFloat(original);
    if (cp > 0 && op > 0) {
      let discont = parseFloat((cp / op) * 10).toFixed(1);
      if (discont.indexOf('.0') > -1) {
        return discont.slice(0, discont.length - 2);
      }
      return discont;
    }
    return '0';
  };

  const formatPriceType3 = useCallback((num = '0') => {
    return parseFloat((num || '0')?.replace('¥', '').replace('￥', ''));
  }, []);

  // 8.7 多了游戏预约的字段处理按钮显示的文字
  const handleText = info => {
    if (info?.appBizType === 0 || info?.appBizType === 1) {
      if (info?.androidType === '3') {
        if (
          info?.sourceInfo &&
          info?.sourceInfo?.sellInfo &&
          (info?.sourceInfo?.sellInfo?.originalPrice || info?.sourceInfo?.sellInfo?.currentPrice)
        ) {
          return '立即购买';
        } else {
          return '立即下载';
        }
      } else {
        return '立即安装';
      }
    } else {
      if (info?.appBizContent) {
        return '立即预约';
      } else {
        if (info?.androidType === '3') {
          if (
            info?.sourceInfo &&
            info?.sourceInfo?.sellInfo &&
            (info?.sourceInfo?.sellInfo?.originalPrice || info?.sourceInfo?.sellInfo?.currentPrice)
          ) {
            return '立即购买';
          } else {
            return '立即下载';
          }
        } else {
          return '立即安装';
        }
      }
    }
  };

  return (
    <div className={styles.detail_simple}>
      <div className="detail_logo">
        <img className="detail_img" src={softDetails.logoFile} />
      </div>
      <div className="detail_info">
        <div className="detail_info_line">
          <div className="detail_info_title">{softDetails.softName}</div>
          {softDetails.score > 70 && (
            <div className="detail_info_score">
              <Rate score={(softDetails.score / 20).toFixed(0)} />
            </div>
          )}
        </div>
      </div>
      {softDetails && softDetails?.payType === 1 && (
        <div className={styles.soft_buyInfos}>
          {softDetails?.originalPrice &&
            softDetails?.currentPrice &&
            softDetails?.originalPrice !== softDetails?.currentPrice && (
              <>
                <div className={`soft_buyInfos_zk`}>
                  {formatDiscount(softDetails?.currentPrice, softDetails?.originalPrice)}折
                </div>
                <div className={`soft_buyInfos_cp`}>
                  <span className={`soft_buyInfos_cp_1`}>￥</span>
                  <span className={`soft_buyInfos_cp_2`}>
                    {formatMoney(parseFloat((softDetails?.currentPrice || 0) / 100))}
                  </span>
                </div>
                <div className={`soft_buyInfos_op`}>
                  ￥{formatMoney(parseFloat((softDetails?.originalPrice || 0) / 100))}
                </div>
              </>
            )}

          {((!softDetails?.originalPrice && softDetails?.currentPrice) ||
            (softDetails?.originalPrice && !softDetails?.currentPrice) ||
            (softDetails?.originalPrice &&
              softDetails?.currentPrice &&
              softDetails?.originalPrice === softDetails?.currentPrice)) && (
            <>
              <div className={`soft_buyInfos_cp`}>
                <span className={`soft_buyInfos_cp_1`}>￥</span>
                <span className={`soft_buyInfos_cp_2`}>
                  {formatMoney(
                    parseFloat(
                      (softDetails?.currentPrice || softDetails?.originalPrice || 0) / 100,
                    ),
                  )}
                </span>
              </div>
            </>
          )}
        </div>
      )}
      {softDetails && softDetails?.androidType === '3' && softDetails?.sourceInfo && (
        <div className={styles.soft_buyInfos}>
          {softDetails?.sourceInfo?.sellInfo?.discount && (
            <div className={`soft_buyInfos_zk`}>
              {softDetails?.sourceInfo?.sellInfo?.discount} 折
            </div>
          )}
          {softDetails?.sourceInfo?.sellInfo?.currentPrice ===
            softDetails?.sourceInfo?.sellInfo?.originalPrice && (
            <>
              {(softDetails?.sourceInfo?.sellInfo?.currentPrice &&
                !softDetails?.sourceInfo?.sellInfo?.originalPrice) ||
                (!softDetails?.sourceInfo?.sellInfo?.currentPrice &&
                  softDetails?.sourceInfo?.sellInfo?.originalPrice && (
                    <div className="soft_buyInfos_cp">
                      <span className={`soft_buyInfos_cp_1`}>￥</span>
                      <span className={`soft_buyInfos_cp_2`}>
                        {formatPriceType3(
                          softDetails?.sourceInfo?.sellInfo?.currentPrice ||
                            softDetails?.sourceInfo?.sellInfo?.originalPrice,
                        )}
                      </span>
                    </div>
                  ))}
              {softDetails?.sourceInfo?.sellInfo?.currentPrice &&
                softDetails?.sourceInfo?.sellInfo?.originalPrice && (
                  <div className={`soft_buyInfos_cp`}>
                    <span className={`soft_buyInfos_cp_1`}>￥</span>
                    <span className={`soft_buyInfos_cp_2`}>
                      {formatPriceType3(softDetails?.sourceInfo?.sellInfo?.currentPrice)}
                    </span>
                  </div>
                )}
            </>
          )}
          {softDetails?.sourceInfo?.sellInfo?.currentPrice !==
            softDetails?.sourceInfo?.sellInfo?.originalPrice && (
            <>
              {softDetails?.sourceInfo?.sellInfo?.currentPrice &&
                !softDetails?.sourceInfo?.sellInfo?.originalPrice && (
                  <div className={`soft_buyInfos_cp`}>
                    <span className={`soft_buyInfos_cp_1`}>￥</span>
                    <span className={`soft_buyInfos_cp_2`}>
                      {formatPriceType3(softDetails?.sourceInfo?.sellInfo?.currentPrice)}
                    </span>
                  </div>
                )}
              {!softDetails?.sourceInfo?.sellInfo?.currentPrice &&
                softDetails?.sourceInfo?.sellInfo?.originalPrice && (
                  <div className={`soft_buyInfos_cp`}>
                    <span className={`soft_buyInfos_cp_1`}>￥</span>
                    <span className={`soft_buyInfos_cp_2`}>
                      {formatPriceType3(softDetails?.sourceInfo?.sellInfo?.originalPrice)}
                    </span>
                  </div>
                )}
              {softDetails?.sourceInfo?.sellInfo?.currentPrice &&
                softDetails?.sourceInfo?.sellInfo?.originalPrice && (
                  <>
                    <div className={`soft_buyInfos_cp`}>
                      <span className={`soft_buyInfos_cp_1`}>￥</span>
                      <span className={`soft_buyInfos_cp_2`}>
                        {formatPriceType3(softDetails?.sourceInfo?.sellInfo?.currentPrice)}
                      </span>
                    </div>
                    <div className={`soft_buyInfos_op`}>
                      {`￥${formatPriceType3(softDetails?.sourceInfo?.sellInfo?.originalPrice)}`}
                    </div>
                  </>
                )}
            </>
          )}
        </div>
      )}
      {softDetails && softDetails.appRecommend && (
        <Btn className={styles.fasterProductBtn} handleClick={handleFasterProduct}>
          <div className={styles.fasterProductIcon} />
          <span className={styles.fasterProductBtnText}>加速</span>
        </Btn>
      )}
      <div className="detail_opt">
        <Button
          soft={{ ...softDetails, bizInfo: softDetails.bizInfo }}
          info={{
            className: styles.soft_btn,
            className_busing: styles.soft_btn_busing,
            className_open: styles.soft_button_open,
            text: handleText(softDetails),
            isCompetitive: true,
            isFasterProduct: true,
            sourceHide: true,
          }}
          logInfo={{
            source: 'AppDetail',
            isSearch: search?.isSearch,
            //   logInfoData.source_p &&
            //   (logInfoData.source_p.indexOf('Search') > -1 ||
            //     logInfoData.source_p.indexOf('Search_Try') > -1 ||
            //     logInfoData.source_p.indexOf('Search_Lenovo') > -1),
          }}
        />
      </div>
    </div>
  );
});
